import get from "lodash/get";
import { GetScore, Lifter, Meet } from "types";
import { toKg } from "util/conversions";
import { getTotal } from "util/lifterHelper";
import { isLbsMeet } from "util/meetHelper";

// Men:
// =weight*500/(-0.000000793954283*bodyWeight^4+0.000493457474*bodyWeight^3-0.1231642956*bodyWeight^2+16.0233664*bodyWeight+45.59224)
// Women:
// =weight*500/(-0.00000255986906*bodyWeight^4+0.00116119212*bodyWeight^3-0.205352889*bodyWeight^2+17.3690866*J100+55.4261)
export const paraDotsFormula = function (
  total: number,
  lifter: Lifter,
  meet: Meet
) {
  if (total <= 0) {
    return 0;
  }

  const parameters = {
    MALE: {
      a: -0.000000793954283,
      b: 0.000493457474,
      c: -0.1231642956,
      d: 16.0233664,
      e: 45.59224,
    },
    FEMALE: {
      a: -0.00000255986906,
      b: 0.00116119212,
      c: -0.205352889,
      d: 17.3690866,
      e: 55.4261,
    },
  };

  let bw = lifter.bodyWeight;

  if (!bw) {
    return 0;
  }

  if (!lifter.gender) {
    return 0;
  }

  if (isLbsMeet(meet)) {
    bw = toKg(bw);
  }

  const p = get(parameters, lifter.gender);
  if (!p) {
    return 0;
  }

  const dotsCoef =
    500.0 /
    (p.a * Math.pow(bw, 4) +
      p.b * Math.pow(bw, 3) +
      p.c * Math.pow(bw, 2) +
      p.d * bw +
      p.e);

  return total * dotsCoef;
};

export const getParaDotsPoints: GetScore = ({
  lifter,
  division,
  meet,
  forecasted,
}) => {
  let total = getTotal({ lifter, division, meet, forecasted });
  if (isLbsMeet(meet)) {
    total = toKg(total);
  }

  return paraDotsFormula(total, lifter, meet);
};
